export const formatCurrency = (amount) => {
  return `GHS ${amount.toFixed(2)}`;
};
